export default __webpack_public_path__ + "static/media/046-canoe.44361ba6.svg";